import React from 'react';
import classNames from 'classnames';
import { Button as NcodedButton } from 'ncoded-component-library';

import { BlockUI } from 'components';

// TODO: import from ncoded-library
export type ButtonProps = {
  isLoading?: boolean;
  icon?: React.ReactNode | React.FC;
  ripple?: boolean;
  variant?: 'solid' | 'outline' | 'link' | 'icon';
  styleType?: 'primary' | 'secondary';
  iconPosition?: 'left' | 'right';
  animateOnClick?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button: React.FC<ButtonProps> = ({
  isLoading,
  children,
  className,
  disabled,
  ...rest
}) => (
  <NcodedButton
    className={classNames('button', className)}
    disabled={isLoading || disabled}
    {...rest}
  >
    <BlockUI loading={isLoading}>{children}</BlockUI>
  </NcodedButton>
);

export default Button;
